import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { images } from "../../config/images";
import { getCuttingStationDetails } from "../ProductionLine/services";
import { toast } from "react-toastify";

const Cutting = ({setCutting, batchId}) => {

  const [cuttingData, setCuttingData] = useState([]);

  useEffect(()=>{
    handleGetCuttingData()
  },[batchId])

    const handleGetCuttingData = async () => {
      try {
        const resp = await getCuttingStationDetails(batchId);
        if (resp.status == 200 || resp.status == 201) {
          setCuttingData(resp.data.payload);
        }
      } catch (error) {
        toast.error(error.response.data.message);
        setCuttingData([]);
        console.log("handlesubmit", error);
      }
    };
  return (
    <>
    <div
      className="modal-container"
      style={{ height: "40vh", top: "35vh" }}
    >
      <div className="modal-header">
        <div className="modal-title">
          CUTTING MACHINE PROCESS SHEET
        </div>
        <div
          onClick={() => setCutting(false)}
          style={{ cursor: "pointer" }}
        >
          <CloseIcon />
        </div>
      </div>
      <div className="modal-table-wrapper">
        <div
          style={{
            width: "100%",
            overflow: "auto",
            maxHeight: "400px",
          }}
          className="gloves-report-data"
        >
          <Table className="dipping-params">
            <TableHead>
              <TableRow>
                <TableCell>Class</TableCell>
                <TableCell>Size</TableCell>
                <TableCell>Actual Length</TableCell>
                <TableCell>Set Length</TableCell>
                <TableCell>Quantity (Nos)</TableCell>
                <TableCell>Operator Name</TableCell>
                <TableCell>QA Signature</TableCell>
                <TableCell>Production Signature</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="gloves-report-body">
              {cuttingData?.map((e) => {
                return (
                  <TableRow>
                    <TableCell>
                      {e.class_name ? e.class_name : "--"}
                    </TableCell>
                    <TableCell>
                      {e.size_name ? e.size_name : "--"}
                    </TableCell>
                    <TableCell>
                      {e.actual_length ? e.actual_length : "--"}
                    </TableCell>
                    <TableCell>
                      {e.set_length ? e.set_length : "--"}
                    </TableCell>
                    <TableCell>
                      {e.quantity ? e.quantity : "--"}
                    </TableCell>

                    <TableCell>
                      {e.operator ? e.operator : "--"}
                    </TableCell>
                    <TableCell>--</TableCell>
                    <TableCell>--</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
    <div
      className="modal-overlay"
      onClick={() => setCutting(false)}
    ></div>
  </>
  );
};

export default Cutting;
